/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var tab_component_1 = require("./tabstrip/rendering/tab.component");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var tabstrip_component_1 = require("./tabstrip/tabstrip.component");
var tabstrip_tab_component_1 = require("./tabstrip/models/tabstrip-tab.component");
var tab_content_directive_1 = require("./tabstrip/directives/tab-content.directive");
var tab_title_directive_1 = require("./tabstrip/directives/tab-title.directive");
var custom_messages_component_1 = require("./tabstrip/localization/custom-messages.component");
var localized_messages_directive_1 = require("./tabstrip/localization/localized-messages.directive");
var kendo_angular_common_1 = require("@progress/kendo-angular-common");
var scrollable_button_component_1 = require("./tabstrip/scrollable-button.component");
var exportedModules = [
    tabstrip_component_1.TabStripComponent,
    tabstrip_tab_component_1.TabStripTabComponent,
    tab_content_directive_1.TabContentDirective,
    tab_title_directive_1.TabTitleDirective,
    tab_component_1.TabComponent,
    custom_messages_component_1.TabStripCustomMessagesComponent,
    localized_messages_directive_1.LocalizedTabStripMessagesDirective
];
var declarations = exportedModules.concat([
    scrollable_button_component_1.TabStripScrollableButtonComponent
]);
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the TabStrip component.
 *
 * The module registers:
 * - `TabStripComponent`&mdash;The `TabStrip` component class.
 * - `TabStripTabComponent`&mdash;The `TabStripTab` component class.
 * - `TabContentDirective`&mdash;The tab content directive used on the `<ng-template>` tag.
 * - `TabTitleDirective`&mdash;The tab title directive used on the `<ng-template>` tag.
 */
var TabStripModule = /** @class */ (function () {
    function TabStripModule() {
    }
    TabStripModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [declarations],
            exports: [exportedModules],
            imports: [common_1.CommonModule, kendo_angular_common_1.ResizeSensorModule]
        })
    ], TabStripModule);
    return TabStripModule;
}());
exports.TabStripModule = TabStripModule;
